// import React from "react";
// import { Link as RouterLink } from "react-router-dom";
// import { Button, Paper, Typography } from "@mui/material";
// import "./CookieConsent.css";
// import CookieIcon from "@mui/icons-material/Cookie";

// const GA_ID = "G-0BG7KPR1E4";
// //const ADS_ID = "AW-XXXXXXXXXX"; // replace with your Google Ads tag ID, or leave null if not using config for Ads
// const STORAGE_KEY = "pa-cookie-consent"; // "accepted" | "rejected"

// function ensureDataLayer() {
//   window.dataLayer = window.dataLayer || [];
//   window.gtag =
//     window.gtag ||
//     function gtag() {
//       window.dataLayer.push(arguments);
//     };
// }

// function loadGoogleTag() {
//   if (window.__googleTagScriptLoaded) return;

//   window.__googleTagScriptLoaded = true;

//   const s = document.createElement("script");
//   s.async = true;
//   s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
//   document.head.appendChild(s);
// }

// function initGoogleConsentMode() {
//   if (window.__googleConsentInitialized) return;

//   ensureDataLayer();
//   loadGoogleTag();

//   window.__googleConsentInitialized = true;

//   window.gtag("js", new Date());

//   // Consent Mode v2 default state
//   // Must run before config/event calls
//   window.gtag("consent", "default", {
//     ad_storage: "denied",
//     ad_user_data: "denied",
//     ad_personalization: "denied",
//     analytics_storage: "denied",

//     // usually fine to allow these because they support core site behavior/security
//     functionality_storage: "granted",
//     security_storage: "granted",

//     // helps if banner/UI is a little delayed
//     wait_for_update: 500,
//   });

//   // GA4
//   window.gtag("config", GA_ID, {
//     anonymize_ip: true,
//   });

//   // Optional: also configure your Google Ads tag if you have one
//   // if (ADS_ID) {
//   //   window.gtag("config", ADS_ID);
//   // }
// }

// function updateConsent(choice) {
//   ensureDataLayer();

//   if (choice === "accepted") {
//     window.gtag("consent", "update", {
//       ad_storage: "granted",
//       ad_user_data: "granted",
//       ad_personalization: "granted",
//       analytics_storage: "granted",
//       functionality_storage: "granted",
//       security_storage: "granted",
//     });
//   } else if (choice === "rejected") {
//     window.gtag("consent", "update", {
//       ad_storage: "denied",
//       ad_user_data: "denied",
//       ad_personalization: "denied",
//       analytics_storage: "denied",
//       functionality_storage: "granted",
//       security_storage: "granted",
//     });
//   }
// }

// export default function CookieHandler() {
//   const [choice, setChoice] = React.useState(() =>
//     localStorage.getItem(STORAGE_KEY)
//   );

//   React.useEffect(() => {
//     initGoogleConsentMode();

//     if (choice === "accepted" || choice === "rejected") {
//       updateConsent(choice);
//     }
//   }, [choice]);

//   const accept = () => {
//     localStorage.setItem(STORAGE_KEY, "accepted");
//     updateConsent("accepted"); // update immediately before any navigation
//     setChoice("accepted");
//   };

//   const reject = () => {
//     localStorage.setItem(STORAGE_KEY, "rejected");
//     updateConsent("rejected"); // update immediately before any navigation
//     setChoice("rejected");
//   };

//   if (choice === "accepted" || choice === "rejected") return null;

//   return (
//     <div
//       className="bws-cookieWrap"
//       role="dialog"
//       aria-live="polite"
//       aria-label="Cookie consent"
//     >
//       <Paper className="bws-cookieCard" elevation={0}>
//         <div className="bws-cookieText">
//           <div className="bws-cookieHeader">
//             <CookieIcon className="bws-cookieIcon" />
//             <Typography className="bws-cookieTitle">Cookies</Typography>
//           </div>

//           <Typography className="bws-cookieBody">
//             We use cookies and similar technologies for analytics and advertising
//             measurement, and to improve the user experience.
//           </Typography>

//           <Typography className="bws-cookieLinks">
//             <RouterLink className="bws-privacyLink" to="/privacy">
//               Privacy Policy
//             </RouterLink>
//           </Typography>
//         </div>

//         <div className="bws-cookieActions">
//           <Button variant="contained" onClick={accept} sx={{ minWidth: "80px" }}>
//             Accept
//           </Button>
//           <Button variant="contained" onClick={reject} sx={{ minWidth: "80px" }}>
//             Reject
//           </Button>
//         </div>
//       </Paper>
//     </div>
//   );
// }

import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Paper, Typography } from "@mui/material";
import CookieIcon from "@mui/icons-material/Cookie";
import "./CookieConsent.css";

const GA_ID = "G-0BG7KPR1E4";
const META_PIXEL_ID = "3240387702828048";

const STORAGE_KEY = "pa-cookie-consent"; // "accepted" | "rejected"

/**
 * Loads and initializes Google Analytics only after consent.
 */
function loadGoogleAnalytics() {
  if (window.__paGaLoaded) return;

  window.__paGaLoaded = true;

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  window.gtag = gtag;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.id = "pa-google-analytics-script";

  document.head.appendChild(script);

  gtag("js", new Date());

  gtag("config", GA_ID, {
    anonymize_ip: true,
  });
}

/**
 * Loads and initializes the Meta Pixel only after consent.
 */
function loadMetaPixel() {
  if (window.__paMetaPixelLoaded) return;

  window.__paMetaPixelLoaded = true;

  ((f, b, e, v, n, t, s) => {
    if (f.fbq) return;

    n = f.fbq = function fbq() {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments);
      } else {
        n.queue.push(arguments);
      }
    };

    if (!f._fbq) {
      f._fbq = n;
    }

    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];

    t = b.createElement(e);
    t.async = true;
    t.src = v;
    t.id = "pa-meta-pixel-script";

    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );

  window.fbq("init", META_PIXEL_ID);
  window.fbq("track", "PageView");
}

/**
 * Loads all tracking services that require consent.
 */
function loadConsentBasedTracking() {
  loadGoogleAnalytics();
  loadMetaPixel();
}

export default function CookieHandler() {
  const [choice, setChoice] = React.useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (error) {
      console.error("Unable to read cookie consent preference:", error);
      return null;
    }
  });

  React.useEffect(() => {
    if (choice === "accepted") {
      loadConsentBasedTracking();
    }
  }, [choice]);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "accepted");
    } catch (error) {
      console.error("Unable to save cookie consent preference:", error);
    }

    setChoice("accepted");
  };

  const reject = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "rejected");
    } catch (error) {
      console.error("Unable to save cookie consent preference:", error);
    }

    setChoice("rejected");
  };

  // Do not display the banner after the visitor has made a choice.
  if (choice === "accepted" || choice === "rejected") {
    return null;
  }

  return (
    <div
      className="bws-cookieWrap"
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      aria-describedby="pa-cookie-description"
    >
      <Paper className="bws-cookieCard" elevation={0}>
        <div className="bws-cookieText">
          <div className="bws-cookieHeader">
            <CookieIcon className="bws-cookieIcon" />

            <Typography className="bws-cookieTitle">
              Cookies
            </Typography>
          </div>

          <Typography
            id="pa-cookie-description"
            className="bws-cookieBody"
          >
            We use cookies to monitor website performance and to improve the user experience.
          </Typography>

          <Typography className="bws-cookieLinks">
            <RouterLink className="bws-privacyLink" to="/privacy">
              Privacy Policy
            </RouterLink>
          </Typography>
        </div>

        <div className="bws-cookieActions">
          <Button
            variant="contained"
            onClick={accept}
            sx={{ minWidth: "80px" }}
          >
            Accept
          </Button>

          <Button
            variant="contained"
            onClick={reject}
            sx={{ minWidth: "80px" }}
          >
            Decline
          </Button>
        </div>
      </Paper>
    </div>
  );
}

// import React from "react";
// import { Link as RouterLink } from "react-router-dom";
// import { Button, Paper, Typography } from "@mui/material";
// import "./CookieConsent.css";
// import CookieIcon from "@mui/icons-material/Cookie";

// const GA_ID = "G-0BG7KPR1E4";
// const STORAGE_KEY = "pa-cookie-consent"; // "accepted" | "rejected"

// function loadGoogleAnalytics() {
//   if (window.__gaLoaded) return;
//   window.__gaLoaded = true;

//   // Load gtag.js
//   const s = document.createElement("script");
//   s.async = true;
//   s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
//   document.head.appendChild(s);

//   // Init gtag
//   window.dataLayer = window.dataLayer || [];
//   function gtag(){ window.dataLayer.push(arguments); }
//   window.gtag = gtag;

//   gtag("js", new Date());
//   gtag("config", GA_ID, { anonymize_ip: true });
// }

// export default function CookieHandler(){
//   const [choice, setChoice] = React.useState(() => localStorage.getItem(STORAGE_KEY));

//   React.useEffect(() => {
//     if (choice === "accepted") loadGoogleAnalytics();
//   }, [choice]);

//   const accept = () => {
//     localStorage.setItem(STORAGE_KEY, "accepted");
//     setChoice("accepted");
//   };

//   const reject = () => {
//     localStorage.setItem(STORAGE_KEY, "rejected");
//     setChoice("rejected");
//   };

//   // If already chosen, don't show banner
//   if (choice === "accepted" || choice === "rejected") return null;

//   return (
//     <div className="bws-cookieWrap" role="dialog" aria-live="polite" aria-label="Cookie consent">
//       <Paper className="bws-cookieCard" elevation={0}>
//         <div className="bws-cookieText">
//           <div className="bws-cookieHeader">
//             <CookieIcon className="bws-cookieIcon" />
//             <Typography className="bws-cookieTitle">Cookies</Typography>
// </div>

//           <Typography className="bws-cookieBody">
//             We use cookies to monitor website performance and to improve the user experience.
//           </Typography>
//           <Typography className="bws-cookieLinks">
//             <RouterLink className="bws-privacyLink" to="/privacy">
//               Privacy Policy
//             </RouterLink>
//           </Typography>
//         </div>

//         <div className="
//         bws-cookieActions">
//           <Button variant="contained" onClick={accept} sx={{minWidth:'80px'}}>
//             Accept
//           </Button>
//           <Button variant="contained" onClick={reject} sx={{minWidth:'80px'}}>
//             Decline
//           </Button>
//         </div>
//       </Paper>
//     </div>
//   );
// }

// // import { React, useEffect, useRef } from "react";
// // import { Link } from "react-router-dom"
// // import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
// // import {useStyle} from '../../context/styleContext/styleContext'
// // import ReactGA from 'react-ga4';
// // const GOOGLE_ID = "G-0BG7KPR1E4"



// // export default function CookieHandler(){

// //   const consentGiven = getCookieConsentValue("CookieConsent");

// //   const { style, setStyle } = useStyle();


// //   if (consentGiven == "true") {
// //     ReactGA.initialize(GOOGLE_ID)
// //   }  

// //   const  accept= () => {

// //       ReactGA.initialize(GOOGLE_ID)
      
// //   };
      

// //   return (  
// // <>
// // <CookieConsent
// //   location="bottom"
// //   buttonText="Okay"
// //   acceptOnScroll='true'
// //   onAccept={(acceptedByScrolling) => {
// //     if (acceptedByScrolling) {
// //       // triggered if user scrolls past threshold
// //     accept();
// //     //alert("Accept was triggered by user scrolling");
// //     } else {
// //     accept();
// //     //alert("Accept was triggered by clicking the Accept button");
// //     }
// //   }}
// //   //cookieName="myAwesomeCookieName2"
// //   style={{ background: style.color4, color:style.color1, minHeight:'10%', alignContent:'center'}}
// //   buttonStyle={{ color: style.color4, fontSize: "16px", fontWeight:'bold', backgroundColor:style.color1 }}
// //   expires={150}
  
// // >
// //   This website uses cookies to enhance the user experience.{" "}
// // </CookieConsent>


// // </>
    
// //   )}

